import React, {PureComponent} from 'react'
import {Route, Switch} from 'react-router-dom'
import UsersTable from './containers/UsersTable'
import UserForm from './containers/UserForm'

export default class Index extends PureComponent {
  render() {
    return (
      <Switch>
        <Route exact path="/users" component={UsersTable} />
        <Route exact path="/users/create" component={UserForm} />

        <Route
          exact
          path="/users/:id"
          component={props => <UserForm {...props} />}
        />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Users/index.tsx